<template>
  <router-view v-if="isRouterAlive"></router-view>
</template>

<script>
  export default {
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true
      }
    },
    watch: {
      // 监听路由
      $route: {
        handler() {
          // this.reload()
        },
        deep:true,
        immediate: true
      },
    },
    methods: {
      reload() {
        this.isRouterAlive = false
        this.$nextTick(() => (this.isRouterAlive = true))
      }
    },
  }
</script>
<style scoped>
</style>
